import React, { useEffect, useState } from 'react'
import {
  PlusCircle as PlusCircleIcon,
  HelpCircle as HelpCircleIcon,
} from 'react-feather'
import {
  Button,
  Container,
  TablePagination,
  Hidden,
  Paper,
  Tooltip,
} from '@material-ui/core'

import {
  Page,
  ContentHeader,
  ServiceUnreachableAlert,
  LoadingFeedback,
  DriveTour,
  ButtonAction,
} from 'components'
import { NewBannerModal, BannersTable } from './components'

import * as service from 'service'
import constants from 'constants/index'
import helpers from 'helpers'

import usePagination from 'hooks/usePagination'
import useStyles from './styles'
import useCookies from 'hooks/useCookies'
import useBrowserReachability from 'hooks/useBrowserReachability'

const CookiesMain = () => {
  const { mixpanel } = helpers
  const {
    COOKIES_BANNERS_DRIVER_STEPS_OBJECT,
    COOKIES_BANNERS_MAIN_DRIVER_STEP,
  } = constants.cookies.banner

  const [loading, setLoading] = useState(false)
  const [openCreateModal, setOpenCreateModal] = useState(false)
  const [openTour, setOpenTour] = useState(false)

  const classes = useStyles()
  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(5)

  const cookiesService = useBrowserReachability(
    constants.externalServices.COOKIES_KEY,
  )

  const { response, isLoading, error, refresh } = useCookies(
    service.cookies.banner.get,
    {
      perPage,
      page,
    },
    [perPage, page],
  )

  const banners = response?.data?.banners

  // Cobre o bloqueio que só se manifesta na requisição real, quando a verificação
  // do host sozinha diria alcançável.
  useEffect(() => {
    if (helpers.services.reachability.isNetworkError(error)) {
      cookiesService.markUnreachable()
    }
    //eslint-disable-next-line
  }, [error])

  const handleCreateModal = () => setOpenCreateModal((prevOpen) => !prevOpen)

  const handleOpenTour = () => {
    setOpenTour(true)
    mixpanel.track('Cookies-Meus-Banners', 'Tour', {
      action: 'tour-meus-banners-cookies',
    })
  }

  return (
    <Page title="Cookies - Meus banners">
      <LoadingFeedback
        open={(isLoading || loading) && cookiesService.isReachable}
      />
      <Container maxWidth={false} className={classes.container}>
        <ContentHeader title="Meus Banners">
          <Tooltip title="Iniciar o tour guiado">
            <Button
              variant="contained"
              color="primary"
              startIcon={<HelpCircleIcon size={20} />}
              onClick={handleOpenTour}
              fullWidth
              id={COOKIES_BANNERS_MAIN_DRIVER_STEP}
            >
              Tutorial
            </Button>
          </Tooltip>

          <ButtonAction
            variant="contained"
            color="primary"
            startIcon={<PlusCircleIcon size={18} />}
            action={handleCreateModal}
            name="Adicionar Site"
            disabled={!cookiesService.isReachable}
          />
        </ContentHeader>
        <ServiceUnreachableAlert
          services={[constants.externalServices.COOKIES_KEY]}
          onRetry={refresh}
        />
        <Paper variant="outlined">
          <BannersTable
            banners={banners}
            isLoading={loading}
            refresh={refresh}
          />
          <TablePagination
            component="div"
            count={response?.data?.meta?.totalCount || 0}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            page={page - 1}
            rowsPerPage={perPage}
            rowsPerPageOptions={[5, 10, 25, 100]}
            labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
            nextIconButtonProps={{ size: 'small' }}
            backIconButtonProps={{ size: 'small' }}
          />
        </Paper>
      </Container>
      <NewBannerModal
        handleCreateModal={handleCreateModal}
        loading={loading}
        open={openCreateModal}
        refresh={refresh}
        setLoading={setLoading}
        setOpen={setOpenCreateModal}
      />
      <DriveTour
        stepsMatrix={COOKIES_BANNERS_DRIVER_STEPS_OBJECT}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default CookiesMain
